import React from 'react';
import { H2 } from 'components/typography';
import { CloseModalIcon } from 'components/icons/style';
import Button from 'components/button';
import withModal, { WithModalProps } from 'hoc/with-modal';
import { Row, WithMargin } from 'components/layout';
import { Text } from './style';
import { useTranslation } from 'i18n';
import { typography } from 'styles/settings';

export interface LogoutConfirmationModalProps extends WithModalProps {
  onConfirm: Function;
}

const defaultProps = {};

function LogoutConfirmationModal({
  modal,
  ...props
}: LogoutConfirmationModalProps) {
  const { t } = useTranslation();

  function logout() {
    props.onConfirm();
  }

  return (
    <>
      <H2>{t('Logout')}</H2>
      <CloseModalIcon onClick={modal.hide} />

      <WithMargin top="28px" bottom="24px">
        <Text>{t('Are you sure that you want to logout?')}</Text>
      </WithMargin>
      <Row>
        <WithMargin right={typography.size.md}>
          <Button label={t('Logout')} onClick={logout} />
        </WithMargin>
        <Button label={t('Cancel')} onClick={modal.hide} secondary />
      </Row>
    </>
  );
}

LogoutConfirmationModal.defaultProps = defaultProps;

export default withModal(LogoutConfirmationModal);
